// extracted by mini-css-extract-plugin
module.exports = {"container":"ultimate_container_1bYV1","icon":"ultimate_icon_2sgT-","cooldownIcon":"ultimate_cooldownIcon_3VZmf","cooldown":"ultimate_cooldown_fvOjI"};